import { StudioSidebarViews } from 'core/constants/enums/StudioSidebarViews.ts';
import { PUBLIC_CANVAS } from 'core/navigation/Routes';

export const APP_HOST_NAME = 'app.rendernet.ai';
export const SHARE_HOST_NAME = 'share.rendernet.ai';
export const SHARE_CANVAS_URL = `https://${SHARE_HOST_NAME}/${PUBLIC_CANVAS}`;
export const WEB_APP_HOST_NAME_SUFFIX = 'web.app';
export const LOCAL_HOST_NAME = 'localhost';

export const INPUT_CHARACTER_LIMIT = 10000;

export const CONTROL_NET_CONTROL_MODE_RADIO_VALUES = [
	{
		label: 'Balanced',
		value: '0',
	},
	{
		label: 'Prompt is more important',
		value: '1',
	},
	{
		label: 'Pose Lock is more important',
		value: '2',
	},
];

export const CONTROL_NET_RESIZE_MODE_RADIO_VALUES = [
	{
		label: 'Resize and Fill',
		value: '0',
	},
	{
		label: 'Crop and Resize',
		value: '1',
	},
	{
		label: 'Just Resize',
		value: '2',
	},
];

export const EXPERIMENTAL_FEATURE_BADGE = '🧪 Experimental';
export const NEW_FEATURE_BADGE = '🎉 New feature';

export const CHARACTER_REGEX_GLOBAL = /\^[^^]+\^/g;

export const CHARACTER_REGEX = /\^[^^]+\^/;

export const CHARACTER_IN_PROMPT_CONSTANT = '^character^';

export const DELETED_CHARACTER_PLACEHOLDER = 'deleted_character';

export const ACTIVE_CHARACTER_STATUS = 'active';
export const DELETED_CHARACTER_STATUS = 'archive';
export const CANVAS_NAME_CHAR_LIMIT = 40;

export const MAX_VIDEO_SIZE = 50 * 1024 * 1024; // 50MB
export const MAX_VIDEO_FRAMES = 1360;
export const MAX_VIDEO_GENERATIONS_ALLOWED = 2;
export const MAX_FACE_SWAP_VIDEO_FRAMES = 340;
export const MAX_AUDIO_SIZE = 50 * 1024 * 1024; // 50MB
export const MAX_AUDIO_DURATION = 300; // 5 minutes
export const DEFAULT_AUDIO_FILE_NAME = 'Untitled';
export const MAX_LIP_SYNC_GENERATIONS_ALLOWED = 3;
export const MAX_AUDIO_UPLOAD_DURATION = 300;

export const LIP_SYNC_GENERATIONS = {
	SCRIPT: 'script',
	AUDIO: 'audio',
};

export const FACE_SWAP_RENDERING_PREFERENCE_OPTIONS = [
	{
		name: 'Speed',
		value: 0,
		ratio: 0.25,
	},
	{
		name: 'Balanced',
		value: 50,
		ratio: 0.5,
	},
	{
		name: 'Quality',
		value: 100,
		ratio: 1,
	},
];

export const FACE_SWAP_RENDERING_PREFERENCE_MAP = FACE_SWAP_RENDERING_PREFERENCE_OPTIONS.reduce(
	(acc, { name, value }) => ({
		...acc,
		[name.toLowerCase()]: { name, value },
	}),
	{},
);

export const NOT_APPLICABLE_DATA_VALUE = 'N/A';

export const ASSETS = {
	homePageVideo: `${process.env.REACT_APP_IMG_BASE_URL}/assets/homepage/home_face_swap_demo.mp4`,
	homePageSampleCharactersImages: [
		`${process.env.REACT_APP_IMG_BASE_URL}/assets/character_studio/character-sample-1.webp`,
		`${process.env.REACT_APP_IMG_BASE_URL}/assets/character_studio/character-sample-2.webp`,
		`${process.env.REACT_APP_IMG_BASE_URL}/assets/character_studio/character-sample-4.webp`,
	],
	homePageSampleNarratorImages: [
		`${process.env.REACT_APP_IMG_BASE_URL}/assets/lip_sync/sample-face-swap-1.webp`,
		`${process.env.REACT_APP_IMG_BASE_URL}/assets/lip_sync/sample-face-swap-2.webp`,
		`${process.env.REACT_APP_IMG_BASE_URL}/assets/lip_sync/sample-face-swap-3.webp`,
	],
	homePageNarratorVideo: `${process.env.REACT_APP_IMG_BASE_URL}/assets/homepage/narrator.mp4`,
	homePageNarratorModalVideo: `${process.env.REACT_APP_IMG_BASE_URL}/assets/lip_sync/narrator-modal-sample-video-without-caption.mp4`,

	homePageFluxCoverImage: `${process.env.REACT_APP_IMG_BASE_URL}/assets/homepage/app_home_flux.webp`,
	homePageFluxCoverImageDesktop: `${process.env.REACT_APP_IMG_BASE_URL}/assets/homepage/home-page-flux-cover-Image-desktop.webp`,
	homePageFaceReplaceImageBefore: `${process.env.REACT_APP_IMG_BASE_URL}/assets/homepage/faceReplace-before.webp`,
	homePageFaceReplaceImageAfter: `${process.env.REACT_APP_IMG_BASE_URL}/assets/homepage/faceReplace-after.webp`,
	homePage8KUpscaleImageBefore: `${process.env.REACT_APP_IMG_BASE_URL}/assets/homepage/upscale-before.webp`,
	homePage8KUpscaleImageAfter: `${process.env.REACT_APP_IMG_BASE_URL}/assets/homepage/upscale-after.webp`,
	homePagePostControlImageBefore: `${process.env.REACT_APP_IMG_BASE_URL}/assets/homepage/poselock-before.webp`,
	homePagePostControlImageAfter: `${process.env.REACT_APP_IMG_BASE_URL}/assets/homepage/poselock-after.webp`,
	homePageTrueTouchImageBefore: `${process.env.REACT_APP_IMG_BASE_URL}/assets/homepage/trueTouch-before.webp`,
	homePageTrueTouchImageAfter: `${process.env.REACT_APP_IMG_BASE_URL}/assets/homepage/trueTouch-after.webp`,
	homePageClothingSwapImageBefore: `${process.env.REACT_APP_IMG_BASE_URL}/assets/change_clothing/clothes_swap_home_card_new_1.webp`,
	homePageClothingSwapImageAfter: `${process.env.REACT_APP_IMG_BASE_URL}/assets/change_clothing/clothes_swap_home_card_new_2.webp`,
	homePageProductPhotoImageBefore: `${process.env.REACT_APP_IMG_BASE_URL}/assets/homepage/product_photo_home_card_before.webp`,
	homePageProductPhotoImageAfter: `${process.env.REACT_APP_IMG_BASE_URL}/assets/homepage/product_photo_home_card_after.webp`,
	homePageMusicVideoImageBefore: `${process.env.REACT_APP_IMG_BASE_URL}/assets/homepage/music_video_home_card_face.webp`,
	homePageMusicVideoImageAfter: `${process.env.REACT_APP_IMG_BASE_URL}/assets/homepage/music_video_home_card_main.webp`,

	homePageVideoAnyoneBannerBackground: `${process.env.REACT_APP_IMG_BASE_URL}/assets/homepage/home_banner_vid_anyone_background.webp`,
	homePageVideoAnyoneCharacterSample: `${process.env.REACT_APP_IMG_BASE_URL}/assets/homepage/home_banner_vid_anyone_character.webp`,
	homePageVideoAnyoneSampleVideo: `${process.env.REACT_APP_IMG_BASE_URL}/assets/homepage/home_banner_vid_anyone_trailer.mp4`,
	homePageVideoAnyoneSampleMobileImage: `${process.env.REACT_APP_IMG_BASE_URL}/assets/homepage/phone_home_banner_vid_anyone_character.webp`,

	characterGeneratePlaceHolderImage: `${process.env.REACT_APP_IMG_BASE_URL}/assets/character_studio/create_character_placeholder.webp`,
	characterUploadPlaceHolderImage: `${process.env.REACT_APP_IMG_BASE_URL}/assets/character_studio/create_character_upload_placeholder.webp`,

	characterNoneSelectedPlaceHolderImage: `${process.env.REACT_APP_IMG_BASE_URL}/assets/character_studio/no_character.webp`,

	imageReferenceStylePlaceHolderImage: `${process.env.REACT_APP_IMG_BASE_URL}/assets/image_ref_style/image_reference_style_placeholder.webp`,

	// home page feature generation
	productPhotoObjectPlaceholderImage: `${process.env.REACT_APP_IMG_BASE_URL}/assets/homepage/product-photo-object-placeholder-image.webp`,
	productPhotoBackgroundPlaceholderImage: `${process.env.REACT_APP_IMG_BASE_URL}/assets/homepage/product-photo-background-image.webp`,
	clothesSwapGarmentPlaceholderImage: `${process.env.REACT_APP_IMG_BASE_URL}/assets/homepage/clothes-swap-garment-placeholder-image.webp`,
	clothesSwapBackgroundPlaceholderImage: `${process.env.REACT_APP_IMG_BASE_URL}/assets/homepage/clothes-swap-background-placeholder-image.webp`,

	homePageNarratorSampleVideos: [
		{
			id: 'ast_Rbmeoyr11t',
			url: 'https://redernet-image-data.s3.amazonaws.com/prod/input_media/face_swap/ast_Rbmeoyr11t.mp4',
			type: 'video',
			width: 1920,
			height: 1080,
			metadata: {
				thumbnail:
					'https://redernet-image-data.s3.amazonaws.com/prod/input_media/face_swap_thumbnail/ast_Rbmeoyr11t-thumbnail.webp',
			},
		},
		{
			id: 'ast_fQz3e1Tpn1',
			url: 'https://redernet-image-data.s3.amazonaws.com/prod/input_media/face_swap/ast_fQz3e1Tpn1.mp4',
			type: 'video',
			width: 1920,
			height: 1080,
			metadata: {
				thumbnail:
					'https://redernet-image-data.s3.amazonaws.com/prod/input_media/face_swap_thumbnail/ast_fQz3e1Tpn1-thumbnail.webp',
			},
		},
		{
			id: 'ast_wPBq4bmAOz',
			url: 'https://redernet-image-data.s3.amazonaws.com/prod/input_media/face_swap/ast_wPBq4bmAOz.mp4',
			type: 'video',
			width: 1920,
			height: 1080,
			metadata: {
				thumbnail:
					'https://redernet-image-data.s3.amazonaws.com/prod/input_media/face_swap_thumbnail/ast_wPBq4bmAOz-thumbnail.webp',
			},
		},
		{
			id: 'ast_uOcbR45s2K',
			url: 'https://redernet-image-data.s3.amazonaws.com/prod/input_media/face_swap/ast_uOcbR45s2K.mp4',
			type: 'video',
			width: 1920,
			height: 1080,
			metadata: {
				thumbnail:
					'https://redernet-image-data.s3.amazonaws.com/prod/input_media/face_swap_thumbnail/ast_uOcbR45s2K-thumbnail.webp',
			},
		},
		{
			id: 'ast_0batUMtrMR',
			url: 'https://redernet-image-data.s3.amazonaws.com/prod/input_media/face_swap/ast_0batUMtrMR.mp4',
			type: 'video',
			width: 1920,
			height: 1080,
			metadata: {
				thumbnail:
					'https://redernet-image-data.s3.amazonaws.com/prod/input_media/face_swap_thumbnail/ast_0batUMtrMR-thumbnail.webp',
			},
		},
	],
	homePageTutorialVideo: [
		{
			id: 'create-your-ai-character',
			imageUrl: `${process.env.REACT_APP_IMG_BASE_URL}/assets/homepage/vid_guide_ai_char_v1.webp`,
			videoUrl: 'https://www.youtube.com/embed/wCbm9U2NQds',
			text: 'Create your first',
			textBold: 'AI Character',
		},
		{
			id: 'hyper-realistic-ai-images',
			imageUrl: `${process.env.REACT_APP_IMG_BASE_URL}/assets/homepage/vid_guide_hyper_real_img_v1.webp`,
			videoUrl: 'https://www.youtube.com/embed/x0yRi50P424',
			text: 'Hyper-Realistic',
			textBold: 'AI Images',
		},
		{
			id: 'create-ai-influencer',
			imageUrl: `${process.env.REACT_APP_IMG_BASE_URL}/assets/homepage/vid_guide_ai_influencer_v1.webp`,
			videoUrl: 'https://www.youtube.com/embed/PfRuBkdLU0I',
			text: 'Create an',
			textBold: 'AI Influencer',
		},
		{
			id: 'ai-character-video',
			imageUrl: `${process.env.REACT_APP_IMG_BASE_URL}/assets/homepage/vid_guide_ai_char_vid_v1.webp`,
			videoUrl: 'https://www.youtube.com/embed/3YE8J0YM48U',
			text: 'AI Character',
			textBold: 'Video',
		},
		{
			id: 'make-your-influencer-talk',
			imageUrl: `${process.env.REACT_APP_IMG_BASE_URL}/assets/homepage/vid_guide_ai_avatar_v1.webp`,
			videoUrl: 'https://www.youtube.com/embed/uxNCtFjXc74',
			text: 'Create your talking',
			textBold: 'AI Influencer',
		},
	],
	homePageVideoAnyoneSampleImages: [
		{
			id: 'ast_x0m3Ngtafs',
			url: `${process.env.REACT_APP_IMG_BASE_URL}/assets/video_anyone/source_template_1.webp`,
			prompt:
				'Camera static. Man talking to the viewer. He is looking straight at the viewer. He is standing still, holding the mic, no other body movement',
		},
		{
			id: 'ast_XdVCxGPOGx',
			url: `${process.env.REACT_APP_IMG_BASE_URL}/assets/video_anyone/source_template_3.webp`,
			prompt: 'Camera static. A cheerleader dancing',
		},
		{
			id: 'ast_S0mFhK7lze',
			url: `${process.env.REACT_APP_IMG_BASE_URL}/assets/video_anyone/source_template_4.webp`,
			prompt: 'A woman riding on a horse. Moving at a medium speed',
		},
	],

	videoAnyoneSampleTemplates: [
		{
			id: 'sample_template_1',
			name: 'Subject Speaking 1',
			prompt:
				'Camera static. Man talking to the viewer. He is looking straight at the viewer. He is standing still, holding the mic, no other body movement',
			imageUrl: `${process.env.REACT_APP_IMG_BASE_URL}/assets/video_anyone/source_template_1.webp`,
			url: `${process.env.REACT_APP_IMG_BASE_URL}/assets/video_anyone/video_template_1.mp4`,
		},
		{
			id: 'sample_template_2',
			name: 'Subject Speaking 2',
			prompt:
				'Camera static. Woman talking to the viewer. She is looking straight at the viewer. She is standing still, No body movement',
			imageUrl: `${process.env.REACT_APP_IMG_BASE_URL}/assets/video_anyone/source_template_2.webp`,
			url: `${process.env.REACT_APP_IMG_BASE_URL}/assets/video_anyone/video_template_2.mp4`,
		},
		{
			id: 'sample_template_3',
			name: 'Subject movement 1',
			prompt: 'Camera static. A cheerleader dancing',
			imageUrl: `${process.env.REACT_APP_IMG_BASE_URL}/assets/video_anyone/source_template_3.webp`,
			url: `${process.env.REACT_APP_IMG_BASE_URL}/assets/video_anyone/video_template_3.mp4`,
		},
		{
			id: 'sample_template_4',
			name: 'Subject movement 2',
			prompt: 'A woman riding on a horse. Moving at a medium speed',
			imageUrl: `${process.env.REACT_APP_IMG_BASE_URL}/assets/video_anyone/source_template_4.webp`,
			url: `${process.env.REACT_APP_IMG_BASE_URL}/assets/video_anyone/video_template_4.mp4`,
		},
		{
			id: 'sample_template_5',
			name: 'Subject movement 3',
			prompt: 'A person riding a bicycle',
			imageUrl: `${process.env.REACT_APP_IMG_BASE_URL}/assets/video_anyone/source_template_5.webp`,
			url: `${process.env.REACT_APP_IMG_BASE_URL}/assets/video_anyone/video_template_5.mp4`,
		},
		{
			id: 'sample_template_6',
			name: 'Subject movement 4',
			prompt:
				'A person riding a jet ski, he is looking into the camera, and the jet ski moves forward at speed',
			imageUrl: `${process.env.REACT_APP_IMG_BASE_URL}/assets/video_anyone/source_template_6.webp`,
			url: `${process.env.REACT_APP_IMG_BASE_URL}/assets/video_anyone/video_template_6.mp4`,
		},
		{
			id: 'sample_template_7',
			name: 'Subject movement 5',
			prompt: 'A woman walking',
			imageUrl: `${process.env.REACT_APP_IMG_BASE_URL}/assets/video_anyone/source_template_7.webp`,
			url: `${process.env.REACT_APP_IMG_BASE_URL}/assets/video_anyone/video_template_7.mp4`,
		},
		{
			id: 'sample_template_8',
			name: 'Camera Static',
			prompt: 'Camera static. Woman standing still, no body movements',
			imageUrl: `${process.env.REACT_APP_IMG_BASE_URL}/assets/video_anyone/source_template_8.webp`,
			url: `${process.env.REACT_APP_IMG_BASE_URL}/assets/video_anyone/video_template_8.mp4`,
		},
		{
			id: 'sample_template_9',
			name: 'Camera Zoom Out',
			prompt: 'Camera pull out. Woman standing still, no body movements',
			imageUrl: `${process.env.REACT_APP_IMG_BASE_URL}/assets/video_anyone/source_template_9.webp`,
			url: `${process.env.REACT_APP_IMG_BASE_URL}/assets/video_anyone/video_template_9.mp4`,
		},
		{
			id: 'sample_template_10',
			name: 'Camera Zoom In',
			prompt: 'Camera push in. Woman standing still, no body movements',
			imageUrl: `${process.env.REACT_APP_IMG_BASE_URL}/assets/video_anyone/source_template_10.webp`,
			url: `${process.env.REACT_APP_IMG_BASE_URL}/assets/video_anyone/video_template_10.mp4`,
		},
		{
			id: 'sample_template_11',
			name: 'Camera Tilt Down',
			prompt: 'Tilt camera down. Woman standing still, no body movements',
			imageUrl: `${process.env.REACT_APP_IMG_BASE_URL}/assets/video_anyone/source_template_11.webp`,
			url: `${process.env.REACT_APP_IMG_BASE_URL}/assets/video_anyone/video_template_11.mp4`,
		},
		{
			id: 'sample_template_12',
			name: 'Camera Tilt Up',
			prompt: 'Tilt camera up. Woman sitting still, no body movements',
			imageUrl: `${process.env.REACT_APP_IMG_BASE_URL}/assets/video_anyone/source_template_12.webp`,
			url: `${process.env.REACT_APP_IMG_BASE_URL}/assets/video_anyone/video_template_12.mp4`,
		},
		{
			id: 'sample_template_13',
			name: 'Camera Move Right',
			prompt: 'Camera move right . Woman standing still, no body movements',
			imageUrl: `${process.env.REACT_APP_IMG_BASE_URL}/assets/video_anyone/source_template_13.webp`,
			url: `${process.env.REACT_APP_IMG_BASE_URL}/assets/video_anyone/video_template_13.mp4`,
		},
		{
			id: 'sample_template_14',
			name: 'Camera Move Left',
			prompt: 'Camera move left . Woman standing still, no body movements',
			imageUrl: `${process.env.REACT_APP_IMG_BASE_URL}/assets/video_anyone/source_template_14.webp`,
			url: `${process.env.REACT_APP_IMG_BASE_URL}/assets/video_anyone/video_template_14.mp4`,
		},
	],
};

export const INVALID_COUPON_CODE_MESSAGE = 'Invalid code!';

export const FREE_VIDEO_ASSET_DATA = {
	id: 'ast_KIvhST7D1W',
	url: 'https://redernet-image-data.s3.amazonaws.com/prod/input_media/lip_sync/ast_KIvhST7D1W.mp4',
	type: 'video',
	width: 1920,
	height: 1080,
	metadata: {
		thumbnail:
			'https://redernet-image-data.s3.amazonaws.com/prod/input_media/face_swap_thumbnail/ast_KIvhST7D1W-thumbnail.webp',
	},
};

export const DEFAULT_PROMPT_VALUE_HOME =
	'Person sitting indoor, bathed in natural sunlight streaming through a nearby window, casting a warm, golden glow on face and the surrounding area.\n\n' +
	'The background consists of a red velvet wall with priceless art hung on the wall. The photo is taken from long distance using a wide angle lens and shows the whole room in detail.\n\n' +
	'The main subject is sitting on is an old royal chair. Subject is wearing modern clothes which are in stark contrast against the aesthetics of the room';

export const DEFAULT_PROMPT_VALUE = '';
export const DEFAULT_NEGATIVE_PROMPT_VALUE =
	'worst, low quality, extra limbs, bad anatomy, bad hands, nsfw, nudity, exposed genitals, breasts';

export const DEFAULT_SELECTED_MODEL = 'mdl_GPGroeVTtf';
export const DEFAULT_SELECTED_STYLE = ['sty_24M6qODZPO', 'sty_QtTUcR2wrK'];
export const DEFAULT_SELECTED_FLUX_MODEL = [];
export const DEFAULT_SELECTED_FLUX_STYLE = ['sty_ycMM2GRkdJ', 'sty_5NUalTpVIN'];

export const apiDocumentationLink = 'https://docs.rendernet.ai/';

export const CURRENT_PROMPT_PLACEHOLDER = '-|-';

export const DEFAULT_NUMBERS_OF_PROMPTS_IN_HOME = 3;
export const generationCostData = {
	[StudioSidebarViews.FLUX]: 5,
	'flux-raw-photo': 10,
};

export const RENDERNET_BASE_URL_DESKTOP_LOGIN = 'https://app.rendernet.ai';
export const RENDERNET_PRICING_URL = 'https://app.rendernet.ai/pricing';

export const TEXT_ASSET_STYLES = {
	color: [
		{ value: 'black', icon: 'color' },
		{ value: 'grey', icon: 'color' },
		{ value: 'light-violet', icon: 'color' },
		{ value: 'violet', icon: 'color' },
		{ value: 'blue', icon: 'color' },
		{ value: 'light-blue', icon: 'color' },
		{ value: 'yellow', icon: 'color' },
		{ value: 'orange', icon: 'color' },
		{ value: 'green', icon: 'color' },
		{ value: 'light-green', icon: 'color' },
		{ value: 'light-red', icon: 'color' },
		{ value: 'red', icon: 'color' },
	],
	size: [
		{ value: 's', icon: 'size-small' },
		{ value: 'm', icon: 'size-medium' },
		{ value: 'l', icon: 'size-large' },
		{ value: 'xl', icon: 'size-extra-large' },
	],
	font: [
		{ value: 'draw', icon: 'font-draw' },
		{ value: 'sans', icon: 'font-sans' },
		{ value: 'serif', icon: 'font-serif' },
		{ value: 'mono', icon: 'font-mono' },
	],
	textAlign: [
		{ value: 'start', icon: 'text-align-left' },
		{ value: 'middle', icon: 'text-align-center' },
		{ value: 'end', icon: 'text-align-right' },
	],
};

export const VALID_IMAGE_TYPES = {
	jpg: 'image/jpeg',
	jpeg: 'image/jpeg',
	png: 'image/png',
};

export const VALID_VIDEO_TYPES = {
	mp4: 'video/mp4',
	webm: 'video/webm',
};

export const VALID_AUDIO_TYPES = {
	mp3: 'audio/mpeg',
};

export const PERSIST_PENDING_GENERATIONS_TIME_LIMIT = 60 * 10; // 10 minutes

export const MUSIC_VIDEO_DISABLED_MESSAGE =
	'Music video feature is temporarily unavailable. It will be back soon.';
